import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClientAuthShell } from "./ClientShell";
import { capi, apiError } from "./clientApi";

export default function ClientLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const res = await capi("/auth/login", { method: "POST", body: { email, password } });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        setErr(apiError(d.detail));
        setBusy(false);
        return;
      }
      navigate("/espace-client");
    } catch {
      setErr("Connexion impossible pour le moment.");
      setBusy(false);
    }
  };

  return (
    <ClientAuthShell>
      <form className="cp-card" onSubmit={submit} data-testid="cp-login-form">
        <h1 className="cp-title">Connexion</h1>
        <p className="cp-sub">Accédez au suivi de vos campagnes SLIZ.</p>
        {err && <p className="cp-error" data-testid="cp-login-error">{err}</p>}
        <div className="cp-field">
          <label htmlFor="cp-email">E-mail</label>
          <input id="cp-email" className="cp-input" type="email" required
            value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="cp-login-email" autoComplete="email" />
        </div>
        <div className="cp-field">
          <label htmlFor="cp-pass">Mot de passe</label>
          <input id="cp-pass" className="cp-input" type="password" required
            value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="cp-login-password" autoComplete="current-password" />
        </div>
        <button className="cp-btn cp-btn-primary" type="submit" disabled={busy}
          data-testid="cp-login-submit">
          {busy ? "Connexion…" : "Se connecter"}
        </button>
        <div className="cp-links">
          <button type="button" className="cp-link"
            onClick={() => navigate("/espace-client/mot-de-passe-oublie")}
            data-testid="cp-login-forgot">Mot de passe oublié ?</button>
        </div>
      </form>
    </ClientAuthShell>
  );
}
